export const CHECKBOX = 'checkbox';
export const DIVIDER = 'divider';
export const ENUMERATION = 'enumeration';
export const HEADER = 'header';
export const IMAGE = 'image';
export const NUMBER_RATING = 'numberrating';
export const MATRIX_RATING = 'matrixrating';
export const PARAGRAPH = 'paragraph';
export const RADIO = 'radio';
export const SELECT = 'select';
export const STAR_RATING = 'starrating';
export const SMILEY_RATING = 'smileyrating';
export const TEXT = 'text';
export const TEXTAREA = 'textarea';
export const EMAIL = 'email';
export const DATE = 'date';
export const RANGE = 'range';
export const RATING = 'rating';
export const SINGLE_CHECKBOX = 'booleancheckbox';
export const NUMBER = 'number';
export const FILE = 'file';
export const PHONE = 'phone';
export const PHONE_NUMBER = 'phonenumber';
export const MOBILE_PHONE = 'mobilephone';
export const SUBMIT = 'submit';
export const PAGE = 'page';
export const NPS = 'nps';
export const CSAT = 'csat';
export const CES = 'ces';
export const SENTIMENT_RATING = 'sentimentrating';